<template>
  <div class="bg">
    <div class="imgBox">
      <!-- <img
        class="img_pre"
        src="http://hbimg.b0.upaiyun.com/b5b96a161f02c70edcb877f84764943916519b3a16d17b-z869x5_fw658"
      >-->
      <!-- <img
        class="img_pre"
        src="http://img.pconline.com.cn/images/photoblog/7/5/6/9/7569444/20101/27/1264577134300.jpg"
      >-->
      <img class="img_pre" :src="url">
      <img
        class="close_icon cursor"
        @click="$emit('close')"
        src="../../assets/img/common/close.png"
        alt
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["url"]
};
</script>
<style lang="less" scoped>
.bg {
  height: 100%;
  width: 100%;
  background: rgba(5, 0, 0, 0.8);
  display: flex;
  position: fixed;
  z-index: 99;
  align-items: center;
  justify-content: center;
  .imgBox {
    background: #fff;
    padding: 10px;
    position: relative;
    max-width: 1024px;
    img {
      max-height: 70vh;
      max-width: 100%;
    }
    .close_icon {
      position: absolute;
      right: -15px;
      top: -15px;
      height: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/imgPreview.vue